import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const ReactQueryDevToolsComponent = ({ isProd }) => {
  if (isProd) return null;

  return <ReactQueryDevtools initialIsOpen={false} />;
};
